import {Component, ElementRef, ViewChild} from '@angular/core';

import {AlertController, NavController, ToastController} from 'ionic-angular';
import { ModalController, ViewController,NavParams } from 'ionic-angular';



import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';
import { UserData } from '../../../providers/user-data';
import { UiData } from "../../../providers/ui-data";
import { JobDataService } from '../../../providers/job-data';

import { SearchPipe } from '../../../pipes/search/search';

import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';

declare var google: any;

@Component({
    selector: 'page-companyaccess',
    templateUrl: 'company-access.html'
})
export class CompanyAccessModal {


    id: any;
    data: any;

    constructor(
        public viewCtrl: ViewController,
        public navParams: NavParams,
        public alertCtrl: AlertController,
        public nav: NavController,
        public userData: UserData,
        public uiData: UiData,
        public navCtrl: NavController,
        public toastCtrl: ToastController,
    ) {

    }
    saveItem() {

    }
    ionViewDidLoad() {

        var that = this;
        that.id = that.navParams.data.id;
        that.data = this.userData.get('companiesAsking/'+that.id);
    }
    accept(){
        this.data.state="accepted";
        this.userData.set('companiesAsking/'+this.id,this.data);
        let toast = this.toastCtrl.create({
            showCloseButton: true,
            cssClass: 'profile-bg',
            message: 'Votre choix a été enregistré, merci.',
            duration: 3000,
            position: 'bottom'
        });
        toast.present();
        this.navCtrl.pop();
    }
    refuse(){
        this.data.state="refused";
        this.userData.set('companiesAsking/'+this.id,this.data);
        let toast = this.toastCtrl.create({
            showCloseButton: true,
            cssClass: 'profile-bg',
            message: 'Votre choix a été enregistré, merci.',
            duration: 3000,
            position: 'bottom'
        });
        toast.present();
        this.navCtrl.pop();
    }
    chooseFavAddress(address) {
        this.data = {
            'mode': 'favorite',
            'data': address
        };
        this.viewCtrl.dismiss(this.data);
    }
    processGooglePlaceData(data) {
        this.data = data;
    }
    dismiss() {
        this.viewCtrl.dismiss(this.data);
    }

}


// WEBPACK FOOTER //
// ./src/pages/utils/company-access/company-access.ts